<template>
    <!-- Testimonial Section -->
	<section class="section testimonial-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center">
						<h2 class="mb-1">Genuine reviews from <span class="text-linear-primary">Customers</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<div class="testimonial-slider owl-carousel nav-center">
                <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                    <Slide v-for="item in Testimonial" :key="item.id">
                        <div class="testimonial-item wow fadeInUp text-start" data-wow-delay="0.2s">
                            <div class="d-flex align-items-center mb-3">
                                <i class="fa-solid fa-star text-warning me-1"></i>
                                <i class="fa-solid fa-star text-warning me-1"></i>
                                <i class="fa-solid fa-star text-warning me-1"></i>
                                <i class="fa-solid fa-star text-warning me-1"></i>
                                <i class="fa-solid fa-star text-warning"></i>
                            </div>
                            <h5 class="mb-2">{{item.Title}}</h5>
                            <p class="mb-4">{{item.Content}}</p>
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center overflow-hidden">
                                    <span class="avatar avatar-lg flex-shrink-0">
                                        <img :src="require(`@/assets/img/profiles/${item.Image}`)" class="img-fluid rounded-circle" alt="img">
                                    </span>
                                    <h6 class="text-truncate ms-2">{{item.Name}}</h6>
                                </div>
                                <p> {{item.Post}}</p>
                            </div>
                        </div>
                    </Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>
			</div>
			<div class="text-center wow fadeInUp mt-5" data-wow-delay="0.2s">
				<h6 class="mb-2">Each listing is designed to be clear and concise, providing customers</h6>
				<p>
					<span class="text-dark fw-medium me-1">Excellent</span>
					<img src="@/assets/img/icons/star-01.svg" class="img-fluid me-1" alt="img">
					<img src="@/assets/img/icons/star-01.svg" class="img-fluid me-1" alt="img">
					<img src="@/assets/img/icons/star-01.svg" class="img-fluid me-1" alt="img">
					<img src="@/assets/img/icons/star-01.svg" class="img-fluid me-1" alt="img">
					<img src="@/assets/img/icons/star-01.svg" class="img-fluid me-1" alt="img">
					<span class="fs-14">Based on 456 reviews</span>
				</p>
			</div>
		</div>
	</section>
	<!-- /Testimonial Section -->

	<!-- Provider Section -->
	<section class="section provide-section bg-black">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-md-6 wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header mb-md-0 mb-3">
						<p class="sub-title fw-medium text-light mb-1">Become a Provider</p>
						<h2 class="text-white">Post your service <span class="text-linear-primary">in a minute</span>
						</h2>
					</div>
				</div>
				<div class="col-md-6 text-md-end wow fadeInUp" data-wow-delay="0.2s">
					<a href="javascript:void(0);" class="btn btn-linear-primary"><i
							class="ti ti-user-filled me-2"></i>Join Us</a>
				</div>
			</div>
		</div>
		<div class="provider-bg1">
			<img src="@/assets/img/bg/provide-bg-01.svg" class="img-fluid" alt="img">
		</div>
		<div class="provider-bg2">
			<img src="@/assets/img/bg/provide-bg-02.svg" class="img-fluid" alt="img">
		</div>
	</section>
	<!-- /Provider Section -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import Testimonial from '@/assets/json/frontend/home-testimonial.json'
import "vue3-carousel/dist/carousel.css";

export default {
    data() {
        return {
            Testimonial: Testimonial,
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 1,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 3,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
}
</script>